import React from 'react';
import { FlagIcon, WrenchIcon, CreditCardIcon } from 'lucide-react';
export function WhyChooseUsSection() {
  const stats = [{
    title: 'U.S.A. Made',
    description: 'All products manufactured in Phoenix, Arizona',
    icon: FlagIcon
  }, {
    title: 'Expert Installation',
    description: 'Our team handles every step from measure to install',
    icon: WrenchIcon
  }, {
    title: 'Financing Available',
    description: 'Affordable monthly payment plans to fit your budget',
    icon: CreditCardIcon
  }];
  return <section className="relative py-16 sm:py-24 md:py-32 parallax-bg" style={{
    backgroundImage: 'url("https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1920&q=80")'
  }} data-id="element-173">
      <div className="absolute inset-0 bg-black/70" data-id="element-174" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6" data-id="element-175">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center mb-10 sm:mb-16 text-shadow" data-id="element-176">
          Why Scottsdale Trusts Us
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12 text-center" data-id="element-177">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <div key={index} className="flex flex-col items-center" data-id="element-178">
                <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full border-2 border-gold/50 flex items-center justify-center mb-4 sm:mb-6 bg-black/20 backdrop-blur-sm" data-id="element-179">
                  <Icon className="w-7 h-7 sm:w-8 sm:h-8 text-white" strokeWidth={1.5} data-id="element-180" />
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4" data-id="element-181">
                  {stat.title}
                </h3>
                <p className="text-white/80 text-base sm:text-lg leading-relaxed max-w-xs mx-auto" data-id="element-182">
                  {stat.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}